import { Post } from "../../../types/posts";

// A Lead Generation post is its graphic: the chosen sentence is the image text and the post has no body.

const joined = (content: string | string[] | undefined): string =>
    (Array.isArray(content) ? content.join("\n\n") : content) || "";

export const leadGenerationText = (slot: {
    content?: string | string[];
    imageText?: string;
}): { content: string; imageText: string } => ({
    content: "",
    imageText: slot.imageText || joined(slot.content),
});

// The wizard's review preview is a "preview" post styled as a graphic; the post page carries the real type.
export const isLeadGeneration = (post: Post): boolean =>
    post.type === "Lead Generation" || (post.type === "preview" && !!post.background && !!post.textColor);

export function withoutLeadGenerationBody(post: Post): Post;
export function withoutLeadGenerationBody(post: Post | null): Post | null;
export function withoutLeadGenerationBody(post: Post | null): Post | null {
    return post && isLeadGeneration(post) ? { ...post, ...leadGenerationText(post) } : post;
}
